import React from "react"
import AnswerOptionsListIndex from "./AnswerOptionsListIndex"

export const ANSWER_OPTIONS_TAB_HEADING = "Answer Options"

const AnswerOptionsTab = () => (
  <>
    <h2 className="tab-title">{ ANSWER_OPTIONS_TAB_HEADING }</h2>
    <AnswerOptionsListIndex />
  </>
)

export default AnswerOptionsTab
